<template>
<div class="contact__wrapper schadensmeldung">
  <v-app class="ast-container">
  <div class="row">
  <div class="col-24 col-xl-12 offset-xl-6">
    <contact-form :name="name" buttonText="Schlüssel bestellen" :requiredFields="requiredFields">
      <schluesselbestellung-form></schluesselbestellung-form>
    </contact-form>
  </div>
  </div>
  </v-app>
</div>
</template>

<script>
import ContactForm from "./ContactForm.vue";
import SchluesselbestellungForm from "./SchluesselbestellungForm";

export default {
  name: "SchluesselbestellungApp",

  components: {
    ContactForm,
    SchluesselbestellungForm
  },

  data() {
    return {
      name: "schluesselbestellung"
    }
  },

  computed: {
    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    }
  }
};
</script>
